import { render, staticRenderFns } from "./promo-list-view.vue?vue&type=template&id=e9aac86a"
import script from "./promo-list-view.vue?vue&type=script&lang=ts"
export * from "./promo-list-view.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9aac86a')) {
      api.createRecord('e9aac86a', component.options)
    } else {
      api.reload('e9aac86a', component.options)
    }
    module.hot.accept("./promo-list-view.vue?vue&type=template&id=e9aac86a", function () {
      api.rerender('e9aac86a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/promo-list-view.vue"
export default component.exports